import { PaymentMethodText } from '../constants/auth-constants'

/**
 * Formats a raw 11-digit Norwegian account number to "XXXX XX XXXXX".
 * Returns the original string unchanged if it does not consist of exactly 11 digits.
 */
export const formatNorwegianAccountNumber = (raw: string): string => {
  const digits = raw.replace(/\D/g, '')
  if (digits.length !== 11) return raw
  return `${digits.slice(0, 4)} ${digits.slice(4, 6)} ${digits.slice(6)}`
}

/**
 * Normalises raw paymentMethodText values returned by the I2I backend so the
 * UI shows the approved Norwegian labels (case and wording).
 *
 * Known raw values are captured in the PaymentMethodText enum.
 */
export const normalizePaymentMethod = (text: string): string => {
  const lower = text.toLowerCase()
  if (lower === PaymentMethodText.AVTALEGIRO.toLowerCase()) return 'Avtalegiro'
  if (lower.includes(PaymentMethodText.FAKTURA.toLowerCase())) return PaymentMethodText.FAKTURA
  return text
}
